import { Component, inject, Input, output, signal } from '@angular/core';
import { NgbActiveModal } from 'node_modules/@ng-bootstrap/ng-bootstrap';
import { Business, BusinessBranch, createEmptyBranch, createEmptyLicenseFields, isNullBranchWithLicense, isNullBusinessBranch, LicenseFields, toBranchWithLicense } from 'src/model/business';
import { createEmptyAddress } from 'src/model/business/address.model';
import { BusinessService } from 'src/services/business.service';
import { ALERT_TYPE, SUCCESS_MESSAGES } from '../constants';
import { SharedService } from '../Shared/shared-service.service';

@Component({
  selector: 'app-add-update-business-branch',
  standalone: false,
  templateUrl: './add-update-business-branch.component.html',
  styleUrl: './add-update-business-branch.component.scss',
})
export class AddUpdateBusinessBranchComponent {
  protected activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private businessService = inject(BusinessService);

  @Input() businessList: Business[];
  @Input() lockBusiness: boolean = false;
  @Input() businessId: number;
  isEdit = signal<boolean>(false);
  branchToUpdate = signal<BusinessBranch>(createEmptyBranch());
  branch = signal<BusinessBranch>(createEmptyBranch());
  passEntry = output<BusinessBranch>();

  license = signal<LicenseFields>(createEmptyLicenseFields());

  minDate = new Date();

  ngOnInit(): void {
    this.resetBusinessBranch();
  }

  resetBusinessBranch() {
    this.branch.set({
      ...this.branchToUpdate(),
      Address: this.branchToUpdate().Address ? { ...this.branchToUpdate().Address } : createEmptyAddress()
    });
    this.license.set(createEmptyLicenseFields());
  }

  async addOrUpdateBusinessBranch() {
    this.branch().BusinessId = this.businessId;
    let b: BusinessBranch;
    let message: string = '';
    const errors = this.isEdit() ? isNullBusinessBranch(this.branch()) : isNullBranchWithLicense(toBranchWithLicense(this.branch(), this.license()));

    if (errors.length > 0) {
      this.sharedService.openAlert(errors.map(e => `- ${e}`).join('\n'), ALERT_TYPE.DANGER);
    } else {
      if (this.isEdit()) {
        b = await this.businessService.putUpdateBusinessBranch(this.branch());
        message = SUCCESS_MESSAGES.UPDATED('business branch');
      } else {
        b = await this.businessService.postAddBusinessBranch(toBranchWithLicense(this.branch(), this.license()));
        message = SUCCESS_MESSAGES.ADDED('new business branch');
      }
      this.passEntry.emit(b);
      this.activeModal.close();
      this.sharedService.openAlert(message, ALERT_TYPE.SUCCESS);
    }
  }
}
